import { Component } from '@angular/core';

@Component({
    selector: 'chevron-back-svg',
    templateUrl: './chevron-back.component.svg',
})
export class ChevronBackComponent { }
